import * as React from 'react';
import { Stack } from '@fluentui/react';
import { baseFontFamilyStyle, THEME_ID } from '../../../shared/styles';
import FileTypeIcon from '../../../components/common/FileTypeIcon';
import { ActionContext } from '../../../context/ActionContext';
import { Spinner, SpinnerSize } from '@fluentui/react/lib/Spinner';

const PMObjectDetail = ({ documents, currentOfficeTheme }) => {
	const { nodeData, isLoading } = React.useContext(ActionContext);
	const loaderStyles = {
		alignItems: 'center',
		display: 'flex',
		justifyContent: 'center',
		width: '100%',
		height: '40px',
		marginTop: '10px',
	};

	const headerTextStyle = {
		fontFamily: baseFontFamilyStyle,
		fontSize: '15px',
		fontWeight: '400',
		fontFamily: baseFontFamilyStyle,
		color:
			currentOfficeTheme.themeId === THEME_ID.BLACK || currentOfficeTheme.themeId === THEME_ID.DARK_GREY
				? currentOfficeTheme.bodyForegroundColor
				: '#5E6367',
		alignItems: 'center',
		textAlign: 'center',
	};

	React.useEffect(() => {}, [documents]);

	const truncateString = (str, len) => {
		if (str) {
			return str.length > 20 ? str.substring(0, 20) + '...' : str;
		}
	};

	return (
		<div style={{ width: '100%', padding: '0 0.5rem' }}>
			<Stack.Item
				style={{
					display: 'flex',
					flexDirection: 'row',
					alignItems: 'center',
					marginBottom: '15px',
					marginTop: '15px',
					background:
						currentOfficeTheme.themeId === THEME_ID.BLACK ||
						currentOfficeTheme.themeId === THEME_ID.DARK_GREY
							? currentOfficeTheme.bodyBackgroundColor
							: '#faf9f8',
				}}
			>
				<h4 style={headerTextStyle}>{` Attachments (${documents.length} of ${nodeData.totalResults})`}</h4>
			</Stack.Item>
			<div
				style={{
					display: 'flex',
					flexDirection: 'row',
					flexWrap: 'wrap',
					color: currentOfficeTheme.bodyForegroundColor,
					background:
						currentOfficeTheme.themeId === THEME_ID.BLACK ||
						currentOfficeTheme.themeId === THEME_ID.DARK_GREY
							? currentOfficeTheme.bodyBackgroundColor
							: '#faf9f8',
				}}
				id="PmAttachmentList"
			>
				{documents.length ? (
					documents?.map((item, index) => {
						return (
							<div
								key={index + ''}
								style={{ display: 'flex', flexDirection: 'row', flex: '0 0 50%' }}
								id="PmAttachment"
							>
								<span style={{ marginRight: '6px' }}>
									<FileTypeIcon
										name={item?.SysrdDocTitle}
										iconStyles={{ margin: '0.5rem 0.5rem 0.5rem 0' }}
									/>
								</span>
								<div> {truncateString(item?.SysrdDocTitle)}</div>
							</div>
						);
					})
				) : (
					<>
						{!isLoading && (
							<Stack.Item
								style={{
									display: 'flex',
									margin: '0 0.1rem',
									width: '99%',
									alignItems: 'center',
									justifyContent: 'center',
									padding: '0.5rem 0.5rem',
									border: `1px solid ${currentOfficeTheme.bodyForegroundColor}`,
									opacity: '0.5',
								}}
							>
								<h4 style={headerTextStyle}>No Records </h4>
							</Stack.Item>
						)}
					</>
				)}
			</div>
			{isLoading && (
				<div style={loaderStyles}>
					<Spinner size={SpinnerSize.large} label="Almost there..." />
				</div>
			)}
		</div>
	);
};

export default PMObjectDetail;
